define('shared/util/state/adapters/session',[],function ( ) {
    return null;
});

